import React, { useState, useCallback, useEffect } from 'react';
import { getLocale } from '@epic-core/common';
import { NewsletterSignup } from './NewsletterSignup';
import VisibilitySensor from 'react-visibility-sensor';
import { useSharedValue } from '@epic-core/hooks';
import { useLocalization } from '@epic-mw/localization';
import {
    NewsletterEngagementActive,
    useMarketoGlobalOptIn,
    useMarketoNewsletterSubscribe,
    useNewsletterAccount
} from '../shared';
import { CardSectionContent, CardSectionWrapper, Card, BgMedia } from 'epic-ue-components';
import { EngamementSection } from './Engagement.styles';
import { NewsletterData, BackgroundProps } from 'epic-ue-shared';
export interface CardData {
    bgMedia?: BackgroundProps;
}

interface Properties {
    newsletterData: NewsletterData & CardData;
    faqHref?: string;
    buttonHref?: string;
    disableIndustrySelect?: boolean;
    marketoLeadParams?: { [key: string]: boolean | number | string };
    epicOptIn?: boolean;
}

export const CenteredEngagementCard: React.FC<Properties> = (props: Properties) => {
    const [isVisible, setIsVisible] = useState(false);
    const getMessage = useLocalization();
    const { account } = useNewsletterAccount();
    const cabinedMode = account?.cabinedMode;

    const onSlideIn = useCallback(
        (inView) => {
            if (inView && !isVisible) {
                setIsVisible(true);
            }
        },
        [isVisible, setIsVisible]
    );
    const [, setNewsletterEngagementActive] = useSharedValue(NewsletterEngagementActive);
    useEffect(() => {
        setNewsletterEngagementActive(true);
        return () => {
            setNewsletterEngagementActive(false);
        };
    }, []);

    const disableIndustrySelect = props.disableIndustrySelect;
    const epicOptIn = props.epicOptIn;
    const marketoLeadParams = props.marketoLeadParams;
    const newsletterData = props.newsletterData || {};
    const staticIndustry = newsletterData.staticIndustry || '';
    const newsletterTitle = newsletterData.title || getMessage('epic.ue.signup.newsletter');
    const newsletterSubTitle = newsletterData.subTitle || '';
    const newsletterPrivacyLabel = newsletterData.privacyLabel || '';
    const newsletterSignUpMsg = newsletterData.signUpMsg || '';
    const newsletterThanksMsg = newsletterData.thanksMsg || '';
    const bgMedia = newsletterData.bgMedia || {};
    const subscriptionStatus = useMarketoGlobalOptIn();
    const { subscribed } = useMarketoNewsletterSubscribe();
    const newsletterSubscribed = subscriptionStatus || subscribed;

    if (cabinedMode) {
        return <></>;
    }

    return (
        <VisibilitySensor
            onChange={onSlideIn}
            partialVisibility
            scrollThrottle={100}
            scrollCheck={true}
            intervalDelay={250}>
            <EngamementSection id="engagementSection" className="engagement-section">
                {bgMedia ? <BgMedia autoplay={true} background={bgMedia} imgMaxWidth={1400} /> : ''}
                <CardSectionWrapper className="card-section">
                    <CardSectionContent>
                        <Card type="overlay">
                            <div className="heading">
                                {newsletterTitle && !newsletterSubscribed ? (
                                    <h2>{newsletterTitle}</h2>
                                ) : (
                                    ''
                                )}
                                {newsletterSubTitle ? (
                                    <p className="bottom">{newsletterSubTitle}</p>
                                ) : (
                                    ''
                                )}
                                <NewsletterSignup
                                    staticIndustry={staticIndustry}
                                    signUpMsg={newsletterSignUpMsg}
                                    thanksMsg={newsletterThanksMsg}
                                    newsletterSubscribed={newsletterSubscribed}
                                    disableIndustrySelect={disableIndustrySelect}
                                    marketoLeadParams={marketoLeadParams}
                                    epicOptIn={epicOptIn}
                                />
                                {!newsletterSubscribed ? (
                                    <a
                                        href={`https://www.epicgames.com/privacypolicy?lang=${getLocale()}`}
                                        className="link">
                                        {newsletterPrivacyLabel}
                                    </a>
                                ) : (
                                    ''
                                )}
                            </div>
                        </Card>
                    </CardSectionContent>
                </CardSectionWrapper>
            </EngamementSection>
        </VisibilitySensor>
    );
};
